var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGospelMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Audio-Book-Music--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Audio Book Music Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.54a1.75 1.75 0 0 0 1.75 -1.75V2.87c0 -0.12 0.09 -0.22 0.29 -0.27l3.41 -1.1a0.3 0.3 0 0 1 0.21 0.05 0.25 0.25 0 0 1 0.09 0.2v2a0.25 0.25 0 0 1 -0.25 0.25A1.75 1.75 0 1 0 20 5.79v-4a1.75 1.75 0 0 0 -0.72 -1.45 1.73 1.73 0 0 0 -1.57 -0.25l-3.5 1.13A1.75 1.75 0 0 0 13 2.88v2.91a0.25 0.25 0 0 1 -0.25 0.25 1.75 1.75 0 0 0 0 3.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93 13a1.75 1.75 0 0 0 1.75 -1.8V7.29a0.25 0.25 0 0 1 0.38 -0.21l0.79 0.48a0.74 0.74 0 0 0 1 -0.25 0.75 0.75 0 0 0 -0.24 -1L7.32 4.86a0.74 0.74 0 0 0 -0.76 0 0.75 0.75 0 0 0 -0.38 0.65V9.2a0.25 0.25 0 0 1 -0.25 0.25 1.75 1.75 0 0 0 0 3.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.55 6.44A1.47 1.47 0 0 0 22.47 6a1 1 0 0 0 -1 1 1 1 0 0 0 0.26 0.66 1 1 0 0 1 0.26 0.67V18a0.51 0.51 0 0 1 -0.48 0.5 18.26 18.26 0 0 0 -7.78 1.89 0.52 0.52 0 0 1 -0.5 0A0.5 0.5 0 0 1 13 20v-7a1 1 0 0 0 -2 0v7a0.5 0.5 0 0 1 -0.24 0.43 0.52 0.52 0 0 1 -0.5 0 18.26 18.26 0 0 0 -7.78 -1.89A0.51 0.51 0 0 1 2 18V8.54a0.48 0.48 0 0 1 0.16 -0.36 0.5 0.5 0 0 1 0.37 -0.18l1 0.08a1 1 0 1 0 0.19 -2C3 6.06 2.3 6 1.53 6A1.5 1.5 0 0 0 0 7.51V19a1.52 1.52 0 0 0 1.48 1.5c4.68 0.07 7.32 1.28 8.63 2.16a5.72 5.72 0 0 1 1.14 1 1 1 0 0 0 1.5 0 5.72 5.72 0 0 1 1.14 -1c1.31 -0.88 3.95 -2.09 8.63 -2.16A1.52 1.52 0 0 0 24 19V7.51a1.51 1.51 0 0 0 -0.45 -1.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGospelMusic);
export default ForwardRef;